export default "__VITE_ASSET__95ab321e__"